module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-2cb45ad3.png";